const Promise = require('es6-promise').Promise;
const ToggleAnime = require('../velocity/toggle-anime');
const { getScrollBarWidth } = require('../modules/element-state');

/**
 * ModalWindow
 * @class
 */
class ModalWindow {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      elms: {
        wrapClass : 'js-mw-wrapper',
        openClass : 'js-mw-open',
        closeClass: 'js-mw-close',
      },
      classNames: {
        overlay   : 'js-mw-overlay',
        isHtmlLock: 'is-mw-lock',
        isOpened  : 'is-mw-opened',
      },
      closeOnOutsideClick: true,
    }
  };

  /**
   * @instance
   * @param _$$el {HTMLElement}
   * @param _opts {object}
   *
   * @example
   *   div.js-mw-wrapper
   *     div.js-mw-open(data-mw-target="sample")
   *   div.js-mw(data-mw-id="sample")
   *     div.js-mw-inner
   *       div.js-mw-close
   */
  constructor(_$$el, _opts = {}) {
    const { elms, classNames, closeOnOutsideClick } = _.defaults(_opts, ModalWindow.defOpts);

    this.$wrap   = document.getElementsByClassName(elms.wrapClass)[0];
    this.$$open  = document.getElementsByClassName(elms.openClass);
    this.$$close = document.getElementsByClassName(elms.closeClass);

    this.classNames = classNames;

    this.$overlay = document.createElement('div');
    this.$overlay.classList.add(this.classNames.overlay);
    document.body.appendChild(this.$overlay);

    this.mwElms = {};
    _.forEach(_$$el, (_$el) => {
      const id = _$el.dataset.mwId;
      this.mwElms[id] = _$el;
    });

    this.openedId = null;

    this.toggle = new ToggleAnime({
      anime: [ 'fadeIn', 'fadeOut' ],
      opts: {
        duration: 200,
        easing  : 'linear',
      },
    });

    window.addEventListener('resize', this.onWindowResized.bind(this), false);
    _.forEach(this.$$open, (_$el) => {
      _$el.addEventListener('click', this.onOpenClicked.bind(this), false);
    });
    _.forEach(this.$$close, (_$el) => {
      _$el.addEventListener('click', this.onCloseClicked.bind(this), false);
    });

    if(closeOnOutsideClick) {
      _.forEach(_$$el, (_$el) => {
        _$el.addEventListener('click', this.onMwClicked.bind(this), false);
      });
    }
  }

  /**
   * @instance
   * @param _id {string}
   */
  open(_id) {
    if(this.openedId) return;

    const $mw_ = this.mwElms[_id];
    const winScorllY_ = window.pageYOffset;

    this.$wrap.style.top = `${ -winScorllY_ }px`;
    $mw_.style.height = `${ window.innerHeight }px`;
    $mw_.style.top = `${ winScorllY_ }px`;

    document.documentElement.classList.add(this.classNames.isHtmlLock);
    document.body.style.height = `${ window.innerHeight }px`;

    Promise.resolve()
    .then(() => {
      return new Promise( (_resolve) => {
        this.toggle.run(true, {
          $el: this.$overlay,
        });
        this.toggle.run(true, {
          $el: $mw_,
          opts: {
            complete: _resolve,
          },
        });
      });
    })
    .then(() => {
      return new Promise( (_resolve) => {
        this.$overlay.classList.add(this.className.isOpened);
        $mw_.classList.add(this.className.isOpened);
        _resolve();
      });
    });

    this.openedId = _id;
  }

  /**
   * @instance
   */
  close() {
    if(!this.openedId) return;

    const $mw_ = this.mwElms[this.openedId];

    const overlayClassList_ = this.$overlay.classList;
    const mwClassList_      = $mw_.classList;

    Promise.resolve()
    .then(() => {
      return new Promise( (_resolve) => {
        this.toggle.run(false, {
          $el: this.$overlay,
        });
        this.toggle.run(false, {
          $el: $mw_,
          opts: {
            complete: _resolve,
          },
        });
      });
    })
    .then(() => {
      return new Promise( (_resolve) => {
        document.documentElement.classList.remove(this.classNames.isHtmlLock);

        window.scrollTo(window.pageXOffset, -parseInt(this.$wrap.style.top));
        this.$wrap.style.top = '';

        this.$overlay.classList.remove(this.className.isOpened);
        $mw_.classList.remove(this.className.isOpened);

        _resolve();
      });
    });

    this.openedId = null;
  }

  /**
   * @instance
   * @private
   */
  onWindowResized() {
    if(!this.openedId) return;

    const $mw_ = this.mwElms[this.openedId];

    $mw_.style.height = `${ window.innerHeight }px`;
    document.body.style.height = `${ window.innerHeight }px`;
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onOpenClicked(_e) {
    _e.preventDefault();
    const targetId = _e.target.dataset.mwTarget;
    this.open(targetId);
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onCloseClicked(_e) {
    _e.preventDefault();
    this.close();
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onMwClicked(_e) {
    const isSelf_ = _.some(this.mwElms, (_$el) => {
      return _e.target === _$el;
    });
    if(!isSelf_) return;
    this.close();
  }

}

/**
 * class exports
 */
module.exports = ModalWindow;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/modal-window.js
 **/